module.exports = __webpack_public_path__ + "assets/GTAmerica-ExpandedBlack.woff";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/fonts/GTAmerica-ExpandedBlack.woff
// module id = 1000
// module chunks = 19